import { useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import slicesThumb from '../../state/slices/thumbslider';
// import { setX, setDragging } from '../../state/actions/createThumbSlider';

export default function useDrag() {
  const position = useSelector((state) => state.thumbslider.x);
  const dragging = useSelector((state) => state.thumbslider.dragging);
  const dispatch = useDispatch();

  const { setX, setDragging } = slicesThumb.actions;

  const [clicked, setClicked] = useState(false);
  // const [dragging, setDragging] = useState(false);
  // const position = useRef(0);

  const dragStart = useCallback((ev) => {
    console.log('in drag start');
    // position.current = ev.clientX;
    dispatch(setX(ev.clientX));
    setClicked(true);
  }, []);

  const dragStop = useCallback(
    () =>
      // NOTE: need some delay so item under cursor won't be clicked
      window.requestAnimationFrame(() => {
        dispatch(setDragging(false));
        setClicked(false);
      }),
    [],
  );

  const dragMove = (ev, cb) => {
    const newDiff = position - ev.clientX;
    const movedEnough = Math.abs(newDiff) > 5;

    if (clicked && movedEnough) {
      dispatch(setDragging(true));
    }

    ev.preventDefault();

    if (dragging && movedEnough) {
      // position.current = ev.clientX;
      dispatch(setX(ev.clientX));
      cb(newDiff);
    }
  };

  return {
    dragStart,
    dragStop,
    dragMove,
  };
}
